<!-- 普通用户或者管理员的后台管理页面头部 -->
<template>
<header class="clearfix">
  <div class="fl">
    <i :style="{transform: collapse && 'rotate(90deg)' || 'none'}" class="iconfont icon-hanbaocaidanzhedie collapse fl" @click="handleCollapse"></i>
    <el-breadcrumb separator="/" class="fl">
      <el-breadcrumb-item v-for="item in breadcrumbList" :key="item.name||item.meta.href" :to="{name:item.name||''}">
        <a v-if="item.meta.href" :href="item.meta.href">
            {{showLang(item.name && (item.name === 'home' && 'ai' || item.name) || 'deepcam')}}
            </a>
        <span v-else>{{showLang(item.name && (item.name === 'home' && 'ai' || item.name) || 'deepcam')}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="userTool fr">
    <!-- <el-tooltip class="item" effect="dark" :content="value && showLang('screen') || showLang('outScreen')" placement="bottom">
      <i style="font-size:20px;vertical-align: middle;color:#fff;" :class="['iconfont',{'icon-quanping':value},{'icon-tuichuquanping-copy':!value}]" @click="handleFullscreen"></i>
    </el-tooltip> -->
    <!-- <lang @change="handleChange" v-if="$config.useI18n" style="padding-left:10px;color: #fff;"></lang> -->
    <el-dropdown class="fr" style="margin-right:16px;" @command="handleCommand">
      <span class="el-dropdown-link">
          <i :class="{userImg:!isUserType,type:isUserType}" v-text="isUserType || 'A'"></i>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="logout">{{showLang('quit')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</header>
</template>

<script>
import lang from '@/components/public/lang';
import {
  mapMutations,
  mapActions
} from "vuex";

export default {
  components: {
    lang
  },
  props: {
    pageSize: {
      type: Object
    },
    breadcrumbList: {
      type: Array,
      default: []
    },
    collapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: true
    };
  },
  computed: {
    isUserType() {
      const data = this.$store.state.admin.accountMessage;
      if (data.is_superuser) return this.showLang('global.admin');
      else if (data.user_type === 2 && !data.is_superuser) return this.showLang('global.enterprise');
      else return false;
    }
  },
  methods: {
    ...mapMutations(['setPageSize']),
    ...mapActions(["handleLogOut"]),
    handleCollapse() {
      const bol = !this.collapse;
      if (bol) {
        this.setPageSize({
          navWidth: 64
        })
      } else {
        this.setPageSize({
          navWidth: 230
        })
      }
      this.$emit('update:collapse', bol)
    },
    handleFullscreen() {
      let main = document.body;
      this.value = !this.value;
      if (this.value) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen();
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen();
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen();
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen();
        }
      }
    },
    handleChange(lang) {
      window.location.reload()
    },
    handleCommand(type) {
      switch (type) {
        case "logout":
          this.handleLogOut()
            .then(res => {
              if (res.code === 1000) {
                this.$router.push({
                  name: "login"
                });
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(this.axiosErr);
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>
header {
  position: absolute;
  z-index: 999;
  height: 60px;
  top: 0;
  right: 0;
  padding: 0 10px;
  box-sizing: border-box;
  line-height: 60px;
  overflow: hidden;
  background-color: #fff;
  border-bottom: none;
  background-color: #438eb9;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05), 0 1px 0 rgba(0, 0, 0, 0.05);
  .userTool {
    width: 200px;
  }
  .collapse,
  .el-breadcrumb {
    line-height: 60px;
    color: #fff;
  }
  .el-icon--right {
    color: #fff;
  }
  .el-breadcrumb {
    height: 60px;
    padding-left: 30px;
    box-sizing: border-box;
  }
  .type{
    color: #fff;
    font-style: normal;
  }
  .userImg {
    display: inline-block;
    width: 36px;
    height: 36px;
    line-height: 36px;
    border-radius: 50%;
    margin: 10px 0 10px 10px;
    background-color: #e2e2e2;
    font-size: 22px;
    text-align: center;
    font-style: normal;
    font-weight: 700;
  }
  .el-dropdown-link i{
    cursor: default;
  }
}

.collapse {
  font-size: 22px;
  transition: 0.3s all ease-in-out;
  cursor: pointer;
  &:hover {
    color: #eee;
  }
}

/deep/.el-breadcrumb__inner {
  &.is-link,
  a {
    color: #fff;
  }
}

/deep/.el-breadcrumb__item {
  &:first-child .el-breadcrumb__inner:hover {
    color: #fff;
    cursor: pointer;
  }
  &:not(:first-of-type) {
    .el-breadcrumb__inner:hover {
      font-weight: 400;
      color: #adcae8;
      cursor: text;
    }
  }
  &:not(:last-of-type) {
    .el-breadcrumb__inner:hover {
      font-weight: 700;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/header.vue